import React from "react";
import "./MultipleSocialProviders.scss";

import { SingleProvider } from "./SingleProvider/SingleProvider";
import CONSTS from "../../helpers/consts";

export default function MultipleSocialProviders({
  currentSocialProvider,
  socialProviders,
  creatorSearchSelectedProviders,
}) {
  const orderedKeys = CONSTS.socialProviderOrder.filter(
    (p) => socialProviders?.[p],
  );

  return (
    <div className="multiple-social-providers">
      {socialProviders &&
        orderedKeys.map((key) => {
          let highlight = false;
          if (creatorSearchSelectedProviders === undefined) {
            highlight = currentSocialProvider === key;
          }

          if (Array.isArray(creatorSearchSelectedProviders)) {
            if (creatorSearchSelectedProviders.length > 0) {
              highlight = creatorSearchSelectedProviders.includes(key);
            } else {
              highlight = true;
            }
          }

          return (
            <SingleProvider
              key={key}
              providerInfo={socialProviders[key]}
              name={key}
              highlight={highlight}
            />
          );
        })}
    </div>
  );
}
